<div ui-view="navbar"></div>
<jhi-alert-error></jhi-alert-error>
<div class="container-fluid">
    <div ui-view="content"></div>
    <jhi-footer></jhi-footer>
</div>



// WEBPACK FOOTER //
// ./src/app/layouts/main/main.component.html